"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const oldJapaneseNumerics = {
    零: '〇',
    壱: '一',
    壹: '一',
    弐: '二',
    弍: '二',
    貳: '二',
    貮: '二',
    参: '三',
    參: '三',
    肆: '四',
    伍: '五',
    陸: '六',
    漆: '七',
    捌: '八',
    玖: '九',
    拾: '十',
    廿: '二十',
    陌: '百',
    佰: '百',
    阡: '千',
    仟: '千',
    萬: '万',
};
exports.default = oldJapaneseNumerics;
